import { Suspense, lazy } from 'react';
import LoadingIndicator from '../common/Loading';

const NotificationCenterPage = lazy(() => import('../components/Notifications/NotificationCenterPage'));

const NotificationCenterLazy: React.FC = () => {
    return (
        <Suspense fallback={<LoadingIndicator />}>
            <NotificationCenterPage />
        </Suspense>
    );
}

export default NotificationCenterLazy;
